<div class="dashboard-container">
    <div class="chart-wrapper" *ngIf="!(isActualMode && !allChannelsSelected)">
        <div *ngIf="loading" class="chart-loading">
            <div class="spinner"></div>
        </div>
        <canvas
            *ngIf="!loading"
            baseChart
            [datasets]="comboChartData"
            [labels]="comboChartLabels"
            [options]="comboChartOptions"
            [chartType]="comboChartType"
            [legend]="true"
        >
        </canvas>
    </div>

    <div class="chart-wrapper">
        <div *ngIf="loading" class="chart-loading">
            <div class="spinner"></div>
        </div>
        <canvas
            *ngIf="!loading"
            baseChart
            [data]="pieChartData"
            [labels]="pieChartLabels"
            [options]="pieChartOptions"
            [colors]="pieChartColors"
            [chartType]="pieChartType"
            [legend]="true"
        >
        </canvas>
    </div>
</div>
